// Shared constants and formatting for the Product Library pages (also used
// by the Line Item Editor)

const PORTAL_ID = "9144184";

// HubSpot's product library, and one product's record (products are 0-7)
export const HUBSPOT_PRODUCTS_URL = `https://app.hubspot.com/contacts/${PORTAL_ID}/objects/0-7/views/all/list`;
export const hubspotProductUrl = (productId) =>
	`https://app.hubspot.com/contacts/${PORTAL_ID}/record/0-7/${productId}`;

// One deal's record in HubSpot (deals are 0-3)
export const hubspotDealUrl = (dealId) =>
	`https://app.hubspot.com/contacts/${PORTAL_ID}/record/0-3/${dealId}`;

export const IN_EDITOR = "In library";

export const pillStyle = (meta) => ({
	display: "inline-flex",
	alignItems: "center",
	height: 20,
	padding: "0 9px",
	borderRadius: 999,
	fontSize: 11,
	fontWeight: 700,
	textTransform: "uppercase",
	letterSpacing: "0.03em",
	whiteSpace: "nowrap",
	background: meta.bg,
	color: meta.fg,
});

// Line item sources: from the library unchanged, edited, or written new
export const SOURCE_PILLS = {
	Library: { fg: "#184c93", bg: "#e8f0fe" },
	Edited: { fg: "#b45309", bg: "#fff3e0" },
	Custom: { fg: "#6d28d9", bg: "#f3e8ff" },
};

const MONTHS = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

// ISO timestamp or "YYYY-MM-DD" -> "Oct 12, 2026"
export const fmtDate = (value) => {
	if (!value) return "—";
	const s = String(value);
	const d = /^\d{4}-\d{2}-\d{2}$/.test(s)
		? new Date(`${s}T12:00:00`)
		: new Date(s);
	if (Number.isNaN(d.getTime())) return "—";
	return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

export const fmtTime = (value) =>
	value
		? new Date(value).toLocaleTimeString("en-US", {
				hour: "numeric",
				minute: "2-digit",
			})
		: "";

// Whole dollars, as the proposals print them
export const fmtMoney = (value) => {
	const n = Number(value);
	if (!Number.isFinite(n)) return "—";
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	}).format(n);
};

export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;
